module.exports = __webpack_public_path__ + "img/table.b3930c2c.svg";